import { render, staticRenderFns } from "./edit-promote.vue?vue&type=template&id=c7a464e2&scoped=true&"
import script from "./edit-promote.vue?vue&type=script&lang=js&"
export * from "./edit-promote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a464e2",
  null
  
)

export default component.exports